import BaseProxy from "../../base-proxy";

export default class SleekBillingsAPI {
  /**
   * @async
   * @function get
   * @param input - Input parameter instance.
   * @param {String} input.companyId - company id used to get the details of subscriptions
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async getSubscriptionsByCompanyId(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/customer-subscriptions?companyId=${input.companyId}`;
    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  /**
   * @async
   * @function createManualRenewalInvoice
   * @param input - Input parameter instance.
   * @param {String} input.companyId - company id
   * @param {String} input.authToken - Token used for issuing authenticated request.
   * @param {Array} input.subscriptions - Array of subscription IDs to renew
   */
  async createManualRenewalInvoice(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/invoices/manual-renewal`;
    const payload = {
      companyId: input.companyId,
      invoiceOrigin: "manualRenewal",
      subscriptions: input.subscriptions,
    };
    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, payload);
  }

  /**
   * @async
   * @function generatePaymentToken
   * @param input - Input parameter instance.
   * @param {String} input.companyId - company id
   * @param {String} input.authToken - Token used for issuing authenticated request.
   * @param {String} input.invoiceId - Invoice ID to generate payment token for
   */
  async generatePaymentToken(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/payment-token`;
    const payload = {
      invoice: input.invoiceId,
      companyId: input.companyId,
      paymentOrigin: "MANUAL_RENEWAL",
    };
    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, payload);
  }

  /**
   * @async
   * @function getInvoicesByCompanyId
   * @param input - Input parameter instance.
   * @param {String} input.companyId - company id used to get the invoice history
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async getInvoicesByCompanyId(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/invoices/company/${input.companyId}`;
    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getCreditCardsByCompanyId(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/credit-cards?companyId=${input.companyId}`;
    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getPaymentMethodsByCompanyId(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/payment-methods?companyId=${input.companyId}`;
    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async getSubscriptionConfig(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/subscription-config?clientType=main`;
    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }

  async createCustomerRequestInvoice(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    let endpointUrl = `${backendUrl}/invoices/customer-request`;
    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  }

  async getSuggestedSubscriptions(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBillingBackendUrl();
    const queryParams = new URLSearchParams();
    queryParams.set("subscriptionId", input.payload.subscriptionId);
    queryParams.set("metaNumber", input.payload.metaNumber);
    let endpointUrl = `${backendUrl}/customer-subscriptions/suggested-subscriptions?${queryParams.toString()}`;
    return await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
  }
}
